import React from 'react';

import { StyledAvatar } from 'components/avatars';
import styled from 'styled-components';
import { FlexContainer, StyledTooltip } from 'styles/common';

import theme from 'constants/theme';

import { Typography4 } from './Typography';

export const StyledBorderAvatar = styled(StyledAvatar)`
  border: 1px solid ${(props) => props.theme.palette.borders.lighterGrey};
  background-color: ${(props) => props.theme.palette.green.main};
  box-sizing: border-box;
  margin-left: -8px;
`;

const StyledMoreCountAvatar = styled.div`
  width: 24px;
  height: 24px;
  margin-left: -8px;
  background: ${(props) => props.theme.palette.background.lightBlue};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;
export const SimpleAvatarGroup = ({ employees = [], totalEmployeesCount, maxAvatarsToShow = 3 }) => {
  if (employees.length === 0) {
    // returning empty div so that at least something takes it place and not break the layout of sibling components,
    // such as in flex container with space-between
    return <div />;
  }

  const showMoreCount = totalEmployeesCount > maxAvatarsToShow ? totalEmployeesCount - maxAvatarsToShow : 0;
  if (showMoreCount) {
    employees = employees.slice(0, maxAvatarsToShow);
  }

  return (
    <FlexContainer style={{ marginLeft: '8px' }}>
      {employees.map(({ id, displayName, profilePhoto }) => (
        <StyledTooltip title={displayName} key={id}>
          <div>
            <StyledBorderAvatar key={id} src={profilePhoto} size="fixed24px" />
          </div>
        </StyledTooltip>
      ))}
      {showMoreCount > 0 && (
        <StyledMoreCountAvatar>
          <Typography4 customColor={theme.palette.text.primaryBlue}>+{showMoreCount}</Typography4>
        </StyledMoreCountAvatar>
      )}
    </FlexContainer>
  );
};

export default SimpleAvatarGroup;
